module.exports = __webpack_public_path__ + "img/lookbook_2_right.b3354d5d.png";